/* eslint-disable*/
import { React, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import {
  Box,
  Divider,
  Typography,
  Menu,
  MenuItem,
  IconButton
} from '@material-ui/core';
import { styled } from '@material-ui/styles';
import Button from '@mui/material/Button';
import { useLocation, useNavigate, a } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changePageflag } from 'feactures/date/dateSlice';
import banner_sidemenu from './images/banner_sidemenu.png';
import oxcim_new_logo from './images/oxcim_new_logo.png';
import bar_graph_icon from './icons/bar_graph.svg';
import circle_graph_icon from './icons/circle_graph.svg';
import circle_graph_icon_red from './icons/circle_graph_red.svg';
import banner_free from './images/banner_free.png';
import banner_year from './images/banner_year.png';
import banner_ope from './images/banner_ope.png';
import banner_trial from './images/banner_trial.png';
import banner_trial_rakuten from './images/banner_trial_rakuten.png';
import graph_icon from './icons/graph.svg';
import human_icon from './icons/human.svg';
import freeBadge from './icons/freebadge.png';
import freeIcon from './icons/freeIcon.png';
import { userinfo, fetchLogout } from 'feactures/user/userSlice';
import { sideMenuProps } from 'feactures/section/pageSlice';
import { changePage } from 'feactures/date/dateSlice';
import SettingsIcon from '@mui/icons-material/Settings';

import moment from 'moment';

const SideMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const menuId = 'side-menu';
  const user = useSelector(userinfo);
  const sideMenuOpen = useSelector(sideMenuProps);
  let trialFlag = false;

  if (user.trial.Amazon.trial || user.trial.楽天.trial) {
    trialFlag = true;
  }

  const handleLogout = async () => {
    await dispatch(fetchLogout())
      .then(unwrapResult) //unwrapResult で,dispatch結果がfulfilledかrejectedかで条件分岐できる
      .then(() => {
        setTimeout(function () {
          navigate('/login');
        }, 2000);
      });
    navigate('/login', { replace: false });
  };

  const CustomButton = styled(Button)({
    textDecoration: 'none',
    color: '#fff',
    borderRadius: 0,
    height: '30px',
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding: '5px 25px 5px 60px',
    // '@media screen and (max-height:800px)': {
    //   height: '35px',
    //   padding: '5px 20px 5px 25px'
    // },
    // '@media screen and (max-height:700px)': {
    //   height: '28px',
    //   padding: '0px 20px 0px 25px',
    //   fontSize: '14px'
    // },
    borderLeft: '4px solid transparent',
    transition: 'all 0.3s ease',
    // textDecoration: 'underline',
    fontSize: '14px',
    '&:hover': {
      color: '#007bff',
      backgroundColor: '#f2f2f2'
      // textDecoration: 'underline',
      // borderLeft: '4px solid #007bff'
    }
  });

  const SelectedButton = styled(Button)({
    textDecoration: 'none',
    color: '#718CC6',
    backgroundColor: '#FFF8E5',
    borderRadius: 0,
    height: '30px',
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding: '5px 25px 5px 60px',
    // '@media screen and (max-height:800px)': {
    //   height: '35px',
    //   padding: '5px 20px 5px 25px'
    // },
    // '@media screen and (max-height:700px)': {
    //   height: '28px',
    //   padding: '0px 20px 0px 25px',
    //   fontSize: '14px'
    // },
    borderLeft: '4px solid transparent',
    transition: 'all 0.3s ease',
    // textDecoration: 'underline',
    fontSize: '14px',
    '&:hover': {
      color: '#007bff',
      backgroundColor: '#f2f2f2'
      // textDecoration: 'underline',
      // borderLeft: '4px solid #007bff'
    }
  });

  const MarketCustomButton = styled(Button)({
    textDecoration: 'none',
    color: '#fff',
    borderRadius: 0,
    height: '30px',
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding: trialFlag ? '5px 25px 5px 29px' : '5px 25px 5px 60px',
    // '@media screen and (max-height:800px)': {
    //   height: '35px',
    //   padding: '5px 20px 5px 25px'
    // },
    // '@media screen and (max-height:700px)': {
    //   height: '28px',
    //   padding: '0px 20px 0px 25px',
    //   fontSize: '14px'
    // },
    borderLeft: '4px solid transparent',
    transition: 'all 0.3s ease',
    // textDecoration: 'underline',
    fontSize: '14px',
    '&:hover': {
      color: '#007bff',
      backgroundColor: '#f2f2f2'
      // textDecoration: 'underline',
      // borderLeft: '4px solid #007bff'
    }
  });

  const MarketSelectedButton = styled(Button)({
    textDecoration: 'none',
    color: '#718CC6',
    backgroundColor: '#FFF8E5',
    borderRadius: 0,
    height: '30px',
    width: '240px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    padding: trialFlag ? '5px 25px 5px 29px' : '5px 25px 5px 60px',
    // '@media screen and (max-height:800px)': {
    //   height: '35px',
    //   padding: '5px 20px 5px 25px'
    // },
    // '@media screen and (max-height:700px)': {
    //   height: '28px',
    //   padding: '0px 20px 0px 25px',
    //   fontSize: '14px'
    // },
    borderLeft: '4px solid transparent',
    transition: 'all 0.3s ease',
    // textDecoration: 'underline',
    fontSize: '14px',
    '&:hover': {
      color: '#007bff',
      backgroundColor: '#f2f2f2'
      // textDecoration: 'underline',
      // borderLeft: '4px solid #007bff'
    }
  });

  const handleClick = (e, path, page) => {
    e.preventDefault();
    navigate(`/app${path}`);
    // dispatchでpathの中身を渡す→DashboardNavbarで受け取って、マーケットのpathだったら更新ボタンを非表示にする
    dispatch(changePageflag(path));
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const page = location.pathname;
  const isMenuOpen = Boolean(anchorEl);
  const amazonStartDate = user.plan.amazon.start_date;
  const amazonEndDate = user.plan.amazon.end_date;
  const rakutenStartDate = user.plan.rakuten.start_date;
  const rakutenEndDate = user.plan.rakuten.end_date;
  const yahooStartDate = user.plan.yahoo.start_date;
  const yahooEndDate = user.plan.yahoo.end_date;

  let yearContract = false;
  if (amazonStartDate !== '' && amazonEndDate !== '') {
    const start = moment(amazonStartDate);
    const end = moment(amazonEndDate).add(1, 'days');
    const diff = end.diff(start, 'month');
    if (diff === 12) {
      yearContract = true;
    }
  }
  if (rakutenStartDate !== '' && rakutenEndDate !== '') {
    const start = moment(rakutenStartDate);
    const end = moment(rakutenEndDate).add(1, 'days');
    const diff = end.diff(start, 'month');
    if (diff === 12) {
      yearContract = true;
    }
  }
  if (yahooStartDate !== '' && yahooEndDate !== '') {
    const start = moment(yahooStartDate);
    const end = moment(yahooEndDate).add(1, 'days');
    const diff = end.diff(start, 'month');
    if (diff === 12) {
      yearContract = true;
    }
  }

  const idList = [
    1, 10, 12, 13, 15, 16, 18, 19, 20, 21, 23, 24, 25, 27, 28, 29, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 43, 44, 45, 47, 51, 53, 54, 55, 56, 61, 62, 63, 65,
    66, 69, 70, 71, 74, 75, 77, 79, 80, 81, 82, 85, 87, 88, 89, 90, 91, 94, 95,
    96, 100, 101, 102, 104, 105, 106, 108, 109, 110, 111, 115, 118, 120, 121,
    122, 123, 124, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137,
    138, 139, 140, 141, 142, 143, 144, 145, 146, 148, 150, 151, 152, 153, 154,
    155, 156, 157, 158, 159, 160, 161, 162, 163, 165, 166, 167, 168, 169, 170,
    171, 172, 173, 174, 175, 176, 177, 178, 180, 181, 183, 184, 185, 186, 187,
    191, 192, 193, 194, 195, 196, 197, 199, 202, 205, 206, 207, 209, 211, 220,
    222, 223, 224, 227, 232, 233, 234, 235, 237, 238, 239, 240, 242, 245, 246,
    247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261,
    262, 263, 264, 266, 267, 268, 269, 270, 271, 272, 274, 275, 276, 278, 279,
    280, 281, 282, 284, 285, 287, 288, 289, 290, 291, 292, 294, 295, 296, 299,
    300, 304, 305, 306, 307, 309, 310, 311, 313, 315, 316, 317, 318, 319, 320,
    321, 322, 323, 324, 326, 327, 329, 331, 332, 333, 336, 337, 338, 345, 346,
    349, 350, 351, 352, 354, 355, 356, 358, 360, 363, 364, 365, 367, 369, 371,
    373, 374, 376, 377, 379, 381, 383, 384, 385, 387, 388, 389, 390, 391, 393,
    395, 396, 397, 398, 399, 400, 405, 406, 409, 411, 412, 413, 414, 415, 416,
    417, 418, 419, 422, 423, 424, 425, 430, 431, 432, 433, 435, 438, 440, 442,
    443, 444, 445, 446, 447, 448, 449, 450, 452, 454, 455, 457, 458, 459, 460,
    462, 463, 464, 465, 466, 467, 468, 469, 471, 474, 475, 476, 478, 479, 480,
    481, 482, 483, 484, 486, 487, 489, 490, 491, 492, 495, 496, 497, 498, 499,
    500, 501, 502, 503, 508, 509, 510, 511, 513, 514, 515, 516, 518, 519, 520,
    523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 535, 536, 537, 539,
    540, 542, 543, 545, 549, 550, 553, 554, 555, 556, 557, 558, 559, 560, 562,
    563, 564, 565, 566, 567, 568, 569, 570, 571, 572, 573, 574, 576, 577, 578,
    579, 580, 581, 582, 584, 585, 586, 587, 589, 592, 593, 594, 595, 596, 597,
    599, 601, 602, 603, 604, 605, 606, 607, 608, 609, 611, 612, 613, 614, 615,
    617, 618, 619, 620, 621, 622, 623, 626, 627, 628, 629, 630, 632, 633, 634,
    635, 636, 637, 638, 639, 640, 641, 642, 644, 645, 647, 648, 649, 650, 651,
    652, 653, 654, 655, 656, 657, 659, 660, 661, 663, 664, 665, 666, 667, 668,
    669, 671, 672, 673, 674, 675, 676, 677, 678, 679, 680, 681, 682, 683, 684,
    685, 686, 687, 688, 689, 690, 691, 693, 694, 695, 696, 698, 699, 700, 701,
    702, 703, 704, 705, 706, 707, 708, 709, 711, 713, 714, 715, 717, 718, 719,
    720, 721, 723, 724, 725, 727, 728, 729, 730, 731, 732, 733, 734, 735, 737,
    738, 740, 741, 742, 743, 744, 745, 746, 747, 748, 749, 750, 751, 752, 753,
    754, 756, 757, 758, 759, 760, 761, 762, 764, 765, 766, 767, 768, 771, 772,
    773, 774, 775, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787,
    788, 789, 790, 791, 792, 793, 794, 795, 796, 798, 799, 800, 801, 802, 803,
    804, 805, 806, 807, 808, 809, 810, 811, 812, 813, 814, 815, 816, 817, 818,
    819, 820, 821, 822, 823, 824, 825, 826, 827, 828, 829, 830, 831, 833, 834,
    835, 836, 837, 838, 839, 840, 841, 842, 843, 844, 845, 846, 847, 849, 850,
    852, 853, 854, 855, 857, 858, 859, 860, 861, 862, 863, 864, 866, 868, 869,
    870, 871, 872, 873, 874, 875, 876, 877, 878, 882, 883, 885, 886, 887, 888,
    889, 890, 891, 892, 893, 894, 895, 896, 897, 898, 899, 900, 901, 902, 903,
    904, 905, 906, 907, 909, 910, 911, 912, 913, 915, 916, 918, 919, 920, 921,
    922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937,
    939, 940, 941, 942, 944, 945, 947, 948, 951, 952, 953, 954, 955, 956, 957,
    958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 972, 974, 975,
    976, 977, 978, 979, 980, 981, 982, 983, 984, 985, 986, 987, 988, 989, 990,
    991, 992, 993, 994, 995, 996, 997, 998, 1000, 1001, 1002, 1003, 1004, 1005,
    1006, 1007, 1009, 1010, 1011, 1012, 1013, 1014, 1015, 1016, 1020, 1021,
    1022, 1023, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033,
    1034, 1035, 1036, 1039, 1040, 1041, 1044, 1046, 1048, 1049, 1050, 1051,
    1052, 1053, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064,
    1065, 1066, 1067, 1072, 1074, 1075, 1077, 1079, 1080, 1082, 1083, 1084, 1086
  ];

  let a_id_flag;
  if (idList.includes(user.accountId)) {
    a_id_flag = true;
  } else {
    a_id_flag = false;
  }

  const today = new Date();
  const targetDate = new Date(today.getFullYear(), 6, 27);

  let banner_url;
  let banner_path;
  if (user.trial.楽天.end_date === '' && a_id_flag && today <= targetDate) {
    banner_url = banner_trial_rakuten;
    banner_path = 'trial';
  } else if (
    user.plan.amazon.plan === 'ご利用なし' &&
    user.plan.rakuten.plan === 'ご利用なし' &&
    user.plan.yahoo.plan === 'ご利用なし'
  ) {
    banner_url = banner_free;
    banner_path = 'plan-change';
  } else if (user.trial.楽天.trial) {
    banner_url = banner_trial;
    banner_path = 'plan-change';
  } else if (yearContract) {
    banner_url = banner_ope;
    banner_path = 'plan-change';
  } else {
    banner_url = banner_year;
    banner_path = 'plan-change';
  }

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePlan = () => {
    handleMenuClose();
    navigate('/app/sys/plan');
  };
  const handleBilling = () => {
    handleMenuClose();
    navigate('/app/sys/billing');
  };

  const handleConnectionStatus = () => {
    handleMenuClose();
    navigate('/app/sys/connection_status');
  };

  const handleRms = () => {
    handleMenuClose();
    navigate('/app/sys/rms');
  };

  const handleChangePass = () => {
    handleMenuClose();
    navigate('/app/sys/p/edit');
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handlePlan}>プラン管理</MenuItem>
      <MenuItem onClick={handleBilling}>ご請求情報</MenuItem>
      <MenuItem onClick={handleConnectionStatus}>データ接続状況</MenuItem>
      <MenuItem onClick={handleRms}>楽天RMS連携設定</MenuItem>
      <MenuItem disabled>Yahoo!API連携設定</MenuItem>
      <MenuItem onClick={handleChangePass}>パスワード変更</MenuItem>
      <MenuItem onClick={handleLogout}>ログアウト</MenuItem>
    </Menu>
  );

  const TrialIcon = () => (
    <img
      src={freeIcon}
      alt="トライアルアイコン"
      style={{ width: '27px', marginRight: '3px' }}
    />
  );

  return (
    <>
      <Box
        position="fixed"
        zIndex={20}
        height="100vh"
        width="240px"
        bgcolor="#718CC6"
        sx={{
          transition: 'left 0.3s',
          left: sideMenuOpen ? 0 : '-100%'
        }}
      >
        <Box
          overflow="auto"
          position="fixed"
          height="100%"
          width="240px"
          color="#fff"
          sx={{
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.05)',
            transition: 'left 0.3s',
            left: sideMenuOpen ? 0 : '-100%'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <img src={oxcim_new_logo} alt="logo" style={{ width: '60%' }} />
            <Box
              sx={{
                border: '1px solid #fff',
                borderRadius: '50px',
                width: '55px',
                height: '55px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <img
                src={human_icon}
                alt="human-icon"
                style={{ width: '40px', height: '40px' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexWrap: 'wrap',
                width: '100%'
              }}
            >
              <Box sx={{ width: '80%' }}>
                <Typography
                  fontSize={'16px'}
                  color="#fff"
                  component={'p'}
                  align="center"
                >
                  {user.accountName}&nbsp;様
                </Typography>
              </Box>
              <IconButton
                onClick={handleProfileMenuOpen}
                sx={{ color: '#fff' }}
              >
                <SettingsIcon />
              </IconButton>
            </Box>
          </Box>
          <Divider
            sx={{ my: 2, border: '1px solid #fff', width: '80%', mx: 'auto' }}
          />
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: '20px' }}>
              <img
                src={graph_icon}
                alt="グラフアイコン"
                style={{ width: '20px' }}
              />
              <Typography
                fontSize="17px"
                fontWeight="600"
                color="#fff"
                pl="10px"
                letterSpacing="1px"
              >
                オーバービュー
              </Typography>
            </Box>
            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/overview' ? (
                  <SelectedButton
                    value="/overview"
                    onClick={(e) => handleClick(e, '/overview')}
                  >
                    -&nbsp;全体実績
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/overview"
                    onClick={(e) => handleClick(e, '/overview')}
                  >
                    -&nbsp;全体実績
                  </CustomButton>
                )}
              </li>
            </ul>
          </Box>
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: '20px' }}>
              <img
                src={bar_graph_icon}
                alt="棒グラフアイコン"
                style={{ width: '20px' }}
              />
              <Typography
                fontSize="17px"
                fontWeight="600"
                pl="10px"
                letterSpacing="1px"
                color="#fff"
              >
                KPIビュー
              </Typography>
            </Box>

            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/monitoring' ? (
                  <SelectedButton
                    value="/monitoring"
                    onClick={(e) => handleClick(e, '/monitoring')}
                  >
                    -&nbsp;KPIサマリ
                  </SelectedButton>
                ) : (
                  <CustomButton
                    value="/monitoring"
                    onClick={(e) => handleClick(e, '/monitoring')}
                  >
                    -&nbsp;KPIサマリ
                  </CustomButton>
                )}
              </li>
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/sales' ? (
              <SelectedButton
                value="/sales"
                onClick={(e) => handleClick(e, '/sales')}
              >
                商品別売上
              </SelectedButton>
            ) : (
              <CustomButton
                value="/sales"
                onClick={(e) => handleClick(e, '/sales')}
              >
                商品別売上
              </CustomButton>
            )}
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            <CustomButton
              value="/numberviews"
              onClick={(e) => handleClick(e, '/numberviews')}
            >
              閲覧数
            </CustomButton>
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            <CustomButton value="/cvr" onClick={(e) => handleClick(e, '/cvr')}>
              CVR
            </CustomButton>
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/unitprice' ? (
              <SelectedButton
                value="/unitprice"
                onClick={(e) => handleClick(e, '/unitprice')}
              >
                販売価格
              </SelectedButton>
            ) : (
              <CustomButton
                value="/unitprice"
                onClick={(e) => handleClick(e, '/unitprice')}
              >
                販売価格
              </CustomButton>
            )}
          </li> */}
            </ul>
          </Box>
          <Box sx={{ mb: '20px' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', ml: '20px' }}>
              <img
                src={circle_graph_icon}
                alt="円グラフアイコン"
                style={{ width: '20px', stroke: '#FFE4DC' }}
              />
              <Typography
                fontSize="17px"
                fontWeight="600"
                pl="10px"
                letterSpacing="1px"
              >
                マーケットビュー
              </Typography>
            </Box>
            <Typography fontSize="14px" fontWeight="600" pl="45px">
              ■市場
            </Typography>
            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/newcategoryboard' ? (
                  <MarketSelectedButton
                    value="/newcategoryboard"
                    onClick={(e) => handleClick(e, '/newcategoryboard')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;カテゴリ分析
                  </MarketSelectedButton>
                ) : (
                  <MarketCustomButton
                    value="/newcategoryboard"
                    onClick={(e) => handleClick(e, '/newcategoryboard')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;カテゴリ分析
                  </MarketCustomButton>
                )}
              </li>

              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/categoryboard' ? (
              <SelectedButton
                value="/categoryboard"
                onClick={(e) => handleClick(e, '/categoryboard')}
              >
                カテゴリ(TOP100)
              </SelectedButton>
            ) : (
              <CustomButton
                value="/categoryboard"
                onClick={(e) => handleClick(e, '/categoryboard')}
              >
                カテゴリ(TOP100)
              </CustomButton>
            )}
          </li>
          <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/ownproductboard' ? (
              <SelectedButton
                value="/ownproductboard"
                onClick={(e) => handleClick(e, '/ownproductboard')}
              >
                間接流通
              </SelectedButton>
            ) : (
              <CustomButton
                value="/ownproductboard"
                onClick={(e) => handleClick(e, '/ownproductboard')}
              >
                間接流通
              </CustomButton>
            )}
          </li> */}
            </ul>
            <Typography fontSize="14px" fontWeight="600" pl="45px">
              ■競合
            </Typography>
            <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/brandanalysis' ? (
                  <MarketSelectedButton
                    value="/brandanalysis"
                    onClick={(e) => handleClick(e, '/brandanalysis')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;店舗/ブランド分析
                  </MarketSelectedButton>
                ) : (
                  <MarketCustomButton
                    value="/brandanalysis"
                    onClick={(e) => handleClick(e, '/brandanalysis')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;店舗/ブランド分析
                  </MarketCustomButton>
                )}
              </li>
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/brandcomparison' ? (
                  <MarketSelectedButton
                    value="/brandcomparison"
                    onClick={(e) => handleClick(e, '/brandcomparison')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;店舗/ブランド比較
                  </MarketSelectedButton>
                ) : (
                  <MarketCustomButton
                    value="/brandcomparison"
                    onClick={(e) => handleClick(e, '/brandcomparison')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;店舗/ブランド比較
                  </MarketCustomButton>
                )}
              </li>
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/measureanalysis' ? (
              <SelectedButton
                value="/measureanalysis"
                onClick={(e) => handleClick(e, '/measureanalysis')}
              >
                店舗/ブランド施策
              </SelectedButton>
            ) : (
              <CustomButton
                value="/measureanalysis"
                onClick={(e) => handleClick(e, '/measureanalysis')}
              >
                店舗/ブランド施策
              </CustomButton>
            )}
          </li> */}
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/productmeasures' ? (
              <SelectedButton
                value="/productmeasures"
                onClick={(e) => handleClick(e, '/productmeasures')}
              >
                商品施策
              </SelectedButton>
            ) : (
              <CustomButton
                value="/productmeasures"
                onClick={(e) => handleClick(e, '/productmeasures')}
              >
                商品施策
              </CustomButton>
            )}
          </li> */}
              <li
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start'
                }}
              >
                {page === '/app/otherproductboard' ? (
                  <MarketSelectedButton
                    value="/otherproductboard"
                    onClick={(e) => handleClick(e, '/otherproductboard')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;商品分析
                  </MarketSelectedButton>
                ) : (
                  <MarketCustomButton
                    value="/otherproductboard"
                    onClick={(e) => handleClick(e, '/otherproductboard')}
                  >
                    {trialFlag && <TrialIcon />}
                    -&nbsp;商品分析
                  </MarketCustomButton>
                )}
              </li>
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/oldotherproductboard' ? (
              <SelectedButton
                value="/oldotherproductboard"
                onClick={(e) => handleClick(e, '/oldotherproductboard')}
              >
                競合商品
              </SelectedButton>
            ) : (
              <CustomButton
                value="/otherproductboard"
                onClick={(e) => handleClick(e, '/oldotherproductboard')}
              >
                競合商品
              </CustomButton>
            )}
          </li> */}
              {/* <li
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start'
            }}
          >
            <i style={{ marginRight: '10px' }}></i>
            {page === '/app/category1/sales' ? (
              <SelectedButton
                value="/category1/sales"
                onClick={(e) => handleClick(e, '/category1/sales')}
              >
                カテゴリNo.1商品
              </SelectedButton>
            ) : (
              <CustomButton
                value="/category1/sales"
                onClick={(e) => handleClick(e, '/category1/sales')}
              >
                カテゴリNo.1商品
              </CustomButton>
            )}
          </li> */}
            </ul>
          </Box>
          <Box sx={{ my: '20px' }}>
            <a
              href={`https://www.oxcim.net/${banner_path}`}
              target="_blank"
              style={{
                width: 'fit-content',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <img
                src={banner_url}
                alt="サイドメニューのバナー"
                style={{ width: '90%' }}
              />
            </a>
          </Box>
        </Box>
      </Box>
      {renderMenu}
    </>
  );
};

export default SideMenu;
